
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('BTN_Custom')]),_c('g',[_c('circle',{staticClass:"cls-1",attrs:{"cx":"400","cy":"400","r":"400"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M428.06,187.49a40.88,40.88,0,1,1-41.19,40.88A41.1,41.1,0,0,1,428.06,187.49Zm-226,222.73a41.2,41.2,0,1,1,41.2,40.88A41.07,41.07,0,0,1,202.05,410.22ZM341.68,526.1a40.6,40.6,0,0,1-16.38,26.83,41.45,41.45,0,0,1-57.52-8.76,40.73,40.73,0,0,1,8.85-57.23,41.45,41.45,0,0,1,57.53,8.76A40.41,40.41,0,0,1,341.68,526.1ZM301,341a40.88,40.88,0,1,1,41.19-40.88A41.1,41.1,0,0,1,301,341Zm123.12,54.48a42.43,42.43,0,0,0,8.47,13.78,40.78,40.78,0,0,0,10,7.15c-4.89,20.32-16.25,32.61-46.12,40.16-9.25,2.34-14.68,8.7-18.26,13.26a46.09,46.09,0,0,1,2.21-44S395.37,399.24,424.09,395.46ZM606.68,216.54l-14.6-9.84C526,160,420.52,141.86,335.68,169.09c-91.94,29.53-158.13,94-181.6,176.87-19.85,70.16-4.56,143.79,41,197,54.29,63.44,122.35,100.73,181.87,100.73a134.73,134.73,0,0,0,17.95-1.19c37.47-5,67.05-26.79,83.33-61.29,15.24-32.28,21.78-56.78,27-76.45,9.6-35.91,14.88-55.68,63.59-85.06,100-60.38,91.23-121.56,77.07-152.67-1.78-3.87-2.07-5.78-4.37-9.5l-9.45-14.77L468.89,398.9c-6,5.9-18.26,4-24.19-1.86-3-2.94-6.44-8.67-6.42-12.82a15.19,15.19,0,0,1,4.5-10.84Z"}})])])
          )
        }
      }
    